/* KK lazy video: videos render with preload="none" and a poster, so nothing downloads at page load.
   A video starts (muted, looping) only while at least 25% of it is on screen and pauses when it leaves,
   so a slider with several videos only streams the ones in view. Reduced-motion users get controls instead. */
class KkVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video || this.observer) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.video.controls = true;
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const playing = this.video.play();
            if (playing && playing.catch) playing.catch(() => {});
          } else if (!this.video.paused) {
            this.video.pause();
          }
        }
      },
      { threshold: 0.25 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.observer = null;
  }
}

if (!customElements.get('kk-video')) customElements.define('kk-video', KkVideo);
